<script setup>
</script>

<template>
  <router-view />
</template>

<style>
body {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
